import type React from 'react';
import { Button } from '@itandi/itandi-bb-ui';
import type { DealConstructionContext } from '~/models/DealConstruction';
import { isDealBillingContext } from '~/models/DealConstruction';
import { getDownloadPath } from '~/utils/api/deals/DealSettlementFile';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';

type Props = {
  constructionContext: DealConstructionContext;
  dealEstimationHistoryContext: DealConstructionContext | null;
  dealEstimationDraftHeader: DealConstructionContext | null;
  handleClickEstimationPreview: (() => void) | null;
  handleClickEstimationHistoryPreview: (() => void) | null;
  handleClickBillingPreview: (() => void) | null;
  billingTarget: 'owner' | 'rentee' | null;
  ownManagement: boolean;
  useSK: boolean;
  isSp: boolean;
};

export const ConstructionDownloadButtons: React.FC<Props> = ({
  constructionContext,
  dealEstimationHistoryContext,
  dealEstimationDraftHeader,
  handleClickEstimationPreview,
  handleClickEstimationHistoryPreview,
  handleClickBillingPreview,
  billingTarget,
  ownManagement,
  useSK,
  isSp
}: Props) => {
  const id = useIdQueryHandler();
  const showSettlementInformation =
    isDealBillingContext(constructionContext) &&
    constructionContext.dealSettlements.length > 0;
  const handleClickSettlementPreview = (): void => {
    if (id === null || billingTarget === null) return;
    const path = getDownloadPath(id, billingTarget);
    window.open(path);
  };
  const handleClickEstimationPreviewDisabled = ((): boolean => {
    if (ownManagement && dealEstimationDraftHeader) {
      return (
        dealEstimationDraftHeader.dealConstructions.length === 0 &&
        constructionContext.dealConstructions.length === 0
      );
    }
    return constructionContext.dealConstructions.length === 0;
  })();
  const showEstimationHistory = dealEstimationHistoryContext && !ownManagement;
  return (
    <>
      {!useSK && billingTarget !== null && (
        <Button
          disabled={!showSettlementInformation}
          onClick={handleClickSettlementPreview}
          variant="secondary"
          width={isSp ? 'fill' : 'default'}
        >
          精算書ダウンロード
        </Button>
      )}
      {handleClickBillingPreview && billingTarget !== null && (
        <Button
          disabled={constructionContext.dealConstructions.length === 0}
          onClick={handleClickBillingPreview}
          variant="secondary"
          width={isSp ? 'fill' : 'default'}
        >
          請求書ダウンロード
        </Button>
      )}
      {handleClickEstimationPreview && (
        <Button
          disabled={handleClickEstimationPreviewDisabled}
          onClick={handleClickEstimationPreview}
          variant="secondary"
          width={isSp ? 'fill' : 'default'}
        >
          {showEstimationHistory
            ? '申請前見積書ダウンロード'
            : '見積書ダウンロード'}
        </Button>
      )}
      {handleClickEstimationHistoryPreview && !ownManagement && (
        <Button
          disabled={
            dealEstimationDraftHeader?.dealConstructions.length === 0 &&
            dealEstimationHistoryContext?.dealConstructions.length === 0
          }
          onClick={handleClickEstimationHistoryPreview}
          variant="secondary"
          width={isSp ? 'fill' : 'default'}
        >
          {dealEstimationHistoryContext
            ? '申請後見積書ダウンロード'
            : '見積書ダウンロード'}
        </Button>
      )}
    </>
  );
};
